import { Alert, Box, Button, Stack, Typography } from "@mui/material";
import { Flex, Loader } from "@zfp-akademie-a-s/zfp-design";
import { AddIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { AnalysisDetailContext } from "Components/Analyses/Detail/AnalysisDetailContext";
import { InvestmentCaseContext } from "Components/Analyses/_Shared/InvestmentCaseContext";
import { useLockedInvestmentCaseStatus } from "Components/Analyses/_Shared/useLockedInvestmentCaseStatus";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { useContext, useState } from "react";
import { GoalsTimeline } from "../Timeline/GoalsTimeline";
import { CreateGoalDrawer } from "./CreateGoalDrawer";

export const GoalsPane: React.FC = () => {
  const { t } = useResource();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const { analysisId, versionId, readOnly: isAnalysisReadOnly } = useContext(AnalysisDetailContext);
  const { lockedCaseStatus, isInvestmentCaseLocked, isInvestmentStatesPending } = useLockedInvestmentCaseStatus(analysisId, versionId);
  const readOnly = isAnalysisReadOnly || isInvestmentCaseLocked;

  if (isInvestmentStatesPending) {
    return <Loader />;
  }

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  return (
    <InvestmentCaseContext.Provider value={{ lockedCaseStatus, isInvestmentCaseLocked }}>
      {/* !important here because of parent spacing */}
      <Stack spacing={Spacing.XXXL} maxWidth={900} sx={{ marginBottom: "120px !important" }}>
        <Flex justifyContent="space-between">
          <Box>
            <Typography variant="h3">{t(Resources.AnalysisDetail.Goals.Title)}</Typography>
            <Typography variant="body2" color="secondary">
              {t(Resources.AnalysisDetail.Goals.Subtitle)}
            </Typography>
          </Box>

          <Box>
            <Button variant="contained" disabled={readOnly} color="secondary" startIcon={<AddIcon />} onClick={() => handleDrawerOpen()}>
              {t(Resources.AnalysisDetail.Goals.AddGoal)}
            </Button>
          </Box>
        </Flex>

        {isInvestmentCaseLocked && <Alert severity="warning">{t(Resources.AnalysisDetail.Goals.LockedAlert)}</Alert>}

        <GoalsTimeline onAddGoal={handleDrawerOpen} />
      </Stack>
      <CreateGoalDrawer open={drawerOpen} onClose={handleDrawerClose} />
    </InvestmentCaseContext.Provider>
  );
};
